<template>
  <div class="inline-block">
    &bull;
    <button
      class="text-blue-700 focus:outline-none font-medium"
      @click="pipelineDialogVisible = true"
    >
      Enter Pipeline
    </button>
    <portal v-if="pipelineDialogVisible" to="app-dialog">
      <PipelinePickerDialog
        :account-id="contactRequest.accountId"
        @input="enterPipeline"
        @close="pipelineDialogVisible = false"
      />
    </portal>
  </div>
</template>

<script>
// import { contactPipelinesClient } from '@/api/clients';
import PipelinePickerDialog from '@/components/Pipelines/PipelinePickerDialog.vue';

export default {
  components: {
    PipelinePickerDialog,
  },
  props: {
    contactRequest: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      pipelineDialogVisible: false,
    };
  },
  inject: ['refresh'],
  methods: {
    async enterPipeline(pipelineId) {
      try {
        await this.$store.dispatch('ui/contactRequestPipeline/update', {
          id: this.contactRequest.id,
          formData: {
            pipelineId,
          },
        });

        this.$emit('change');

        await this.refresh();
      } catch (error) {
        //
      }
    },
  },
};
</script>
,
